import SeatReservationSummary from './SeatReservationSummary';

export default SeatReservationSummary;
